module.exports = __webpack_public_path__ + "img/hoc_vien.93f0fe62.svg";